import limits from "../../../../../functions/src/commerce/limits.json";

export const reportPriceLabel = new Intl.NumberFormat("en-US", {
  style: "currency", currency: limits.currency
}).format(limits.reportPriceCents / 100);
export const reportPriceWithCurrency = `${reportPriceLabel} ${limits.currency.toUpperCase()}`;
